import useEvent from "react-use-event-hook";
import { useResetRecoilState } from "recoil";

import {
  investigationFollowVehicleAtom,
  investigationShowCarAtom,
  investigationShowDetourAtom,
  investigationShowNoGpsAtom,
  investigationShowPlannedAtom,
  investigationShowStationsAtom,
  investigationShowTrackingAtom,
  investigationStationLabelsAtom,
} from "@ryde/shared";

/**
 * Returns the layer filters and the follow-the-vehicle camera to their defaults so the next
 * investigation opens fresh.
 *
 * These live in app-scoped Recoil atoms rather than in the overlay, so nothing unmounts them — which is why
 * the caller has to be a component that OUTLIVES the overlay. Playback state (playing, speed, last fired
 * event) deliberately is not here: it is `useState` inside the playback provider and dies with it.
 */
export const useResetInvestigationSelections = (): (() => void) => {
  const resetShowPlanned = useResetRecoilState(investigationShowPlannedAtom);
  const resetShowTracking = useResetRecoilState(investigationShowTrackingAtom);
  const resetShowNoGps = useResetRecoilState(investigationShowNoGpsAtom);
  const resetShowDetour = useResetRecoilState(investigationShowDetourAtom);
  const resetShowStations = useResetRecoilState(investigationShowStationsAtom);
  const resetShowCar = useResetRecoilState(investigationShowCarAtom);
  const resetStationLabels = useResetRecoilState(
    investigationStationLabelsAtom,
  );
  const resetFollowVehicle = useResetRecoilState(
    investigationFollowVehicleAtom,
  );

  return useEvent(() => {
    resetShowPlanned();
    resetShowTracking();
    resetShowNoGps();
    resetShowDetour();
    resetShowStations();
    resetShowCar();
    resetStationLabels();
    resetFollowVehicle();
  });
};
